import { RadioButtonTemplate, RadioButtonTemplateProps } from "./template";

export type RadioButtonProps = RadioButtonTemplateProps;

export const RadioButton = (props: RadioButtonProps): JSX.Element => {
  return <RadioButtonTemplate {...props} />;
};
